import React from 'react';
import { Container, Typography, Grid, Card, CardMedia, CardContent, List, ListItem, ListItemText } from '@mui/material';
import services from '../data/servicesData';

export default function Services() {
  return (
    <Container sx={{ py: 6 }}>
      <Typography variant="h4" align="center" gutterBottom>Our Services</Typography>
      <Grid container spacing={4} sx={{ mt: 2 }}>
        {services.map((s) => (
          <Grid item xs={12} key={s.slug}>
            <Card
              sx={(theme) => ({
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'stretch',
                borderRadius: 2,
                overflow: 'hidden',
                boxShadow: theme.shadows[3],
                transition: 'transform 200ms ease, box-shadow 200ms ease',
                '&:hover': { transform: 'translateY(-6px)', boxShadow: theme.shadows[6] }
              })}
            >
              <CardMedia
                component="img"
                image={s.image}
                alt={s.title}
                sx={{
                  width: '100%',
                  height: { xs: 220, md: 320 },
                  objectFit: 'cover'
                }}
              />

              <CardContent sx={{ p: { xs: 2, md: 3 } }}>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>{s.title}</Typography>
                <Typography color="text.secondary" sx={{ mb: 1 }}>{s.short}</Typography>
                <Typography sx={{ mb: 2 }}>{s.description}</Typography>
                <Typography variant="subtitle2">What we deliver</Typography>
                <List>
                  {s.features.map(f => (
                    <ListItem key={f} sx={{ py: 0 }}>
                      <ListItemText primary={f} />
                    </ListItem>
                  ))}
                </List>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
